var _style, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 42",
    style: {
      enableBackground: "new 0 0 40 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t\t\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t\t\t.st2{fill:#FFFFFF;}\n\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.5375,
    y1: 4.5375,
    x2: 38.4625,
    y2: 41.4625,
    gradientTransform: "matrix(1 0 0 -1 0 44)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DB437"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52D060"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33,42H7c-3.9,0-7-3.1-7-7V7c0-3.9,3.1-7,7-7h26c3.9,0,7,3.1,7,7v28C40,38.9,36.9,42,33,42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.4,27c-0.3,1-1.7,1.8-2.8,2c-0.8,0.2-1.7,0.3-5.1-1.1c-3.7-1.5-8.9-7.1-8.9-10.7c0-1.9,1.1-4,3-4 c0.9,0,1.1,0,1.4,0.7c0.3,0.8,1.2,2.9,1.3,3.1c0.4,0.9-0.4,1.4-1,2.1c-0.2,0.2-0.4,0.5-0.2,0.9c0.2,0.4,1.1,1.8,2.3,2.9 c1.6,1.4,2.9,1.9,3.4,2.1c0.3,0.1,0.8,0.1,1-0.2c0.3-0.3,0.7-0.9,1.1-1.5c0.3-0.4,0.7-0.5,1-0.3c0.3,0.1,3.6,1.6,3.7,1.9 C28.8,25.1,28.8,26,28.4,27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20,7.9c7.2,0,13.1,5.9,13.1,13.1S27.2,34.1,20,34.1c-2.6,0-5.1-0.7-7.2-2.2L12,31.5l-0.9,0.3l-2.2,0.7 l0.7-2.1l0.3-0.9l-0.6-0.8c-0.8-1.1-1.4-2.3-1.8-3.6c-0.4-1.3-0.7-2.7-0.7-4.1C6.9,13.8,12.8,7.9,20,7.9L20,7.9 M20,6L20,6 C11.7,6,5,12.7,5,21c0,3.3,1.1,6.3,2.9,8.8L6,35.4l5.8-1.8C14.1,35.1,17,36,20,36c8.3,0,15-6.7,15-15S28.3,6,20,6L20,6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIconGreen);
export default __webpack_public_path__ + "static/media/whatsapp_icon_green.c00e7d03686657f16b2febe12453a9ec.svg";
export { ForwardRef as ReactComponent };